/* unplugin-vue-components disabled */import { render } from "./todaysHeadlines.vue?vue&type=template&id=55520c6c&scoped=true"
import script from "./todaysHeadlines.vue?vue&type=script&lang=js"
export * from "./todaysHeadlines.vue?vue&type=script&lang=js"

import "./todaysHeadlines.vue?vue&type=style&index=0&id=55520c6c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55520c6c"]])

export default __exports__